import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 8F48F520-011A-4B09-853E-33E1C7D5714A
 * name pause-box-outline
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pause-box-outline.svg
 * tags
 * - Audio 
 * - Music 
 */
export const PauseBoxOutlineIcon = createSvgIcon(<><path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M19 19H5V5H19V19M13 16V8H15V16H13M9 16V8H11V16H9" /></>, 'PauseBoxOutlineIcon');
export default PauseBoxOutlineIcon